var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.684,
    cy: 24.684,
    r: 24.684,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6154 18.1016H34.147V29.2094H18.1024V31.6778C18.1024 32.3566 18.6578 32.912 19.3366 32.912H32.9128L37.8496 37.8488V19.3358C37.8496 18.657 37.2942 18.1016 36.6154 18.1016ZM31.678 25.5068V14.399C31.678 13.7202 31.1227 13.1648 30.4438 13.1648H14.3992C13.7204 13.1648 13.165 13.7202 13.165 14.399V31.6778L18.1018 26.741H30.4438C31.1227 26.741 31.678 26.1856 31.678 25.5068Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCircle);
export default __webpack_public_path__ + "static/media/ChatCircle.514a865d15cea7e5b8a0c8b3ac7f457f.svg";
export { ForwardRef as ReactComponent };